module.exports = __webpack_public_path__ + "assets/images/typeofcar-03.bc87bab18e697ac2b6ad616931b4bacc.svg";